<script>
export default {
  props: {
    label: String,
    options: Array,
    defaultValue: String,
    selectedValue: [String, Array],
    hasRemoveButton: Boolean,
    multiSelect: Boolean,
    open: Boolean
  },

  data() {
    return {
      listenToOutsideClick: false
    };
  },

  computed: {
    formattedSelectedValue() {
      const selectedValue = this.selectedValue;
      if (!selectedValue) {
        return;
      }
      const hasComma = selectedValue.includes(',');
      if (hasComma) {
        return selectedValue.replace(',', ' - ');
      }

      const isNumberRange = selectedValue.length && selectedValue.length === 2;
      if (isNumberRange) {
        const [min, max] = selectedValue;
        return `$${min} - $${max}`;
      }
      return selectedValue;
    }
  },

  methods: {
    closeDropdown() {
      if (!this.listenToOutsideClick) {
        return;
      }
      this.$emit('toggle', false);
    }
  },

  mounted() {
    // prevent the outside-click from getting called on mounted (bug?)
    setTimeout(() => {
      this.listenToOutsideClick = true;
    });
  }
};
</script>

<template>
  <div v-click-outside="closeDropdown" class="app-dropdown">
    <div class="dropdown-container">
      <button class="dropdown-button" @click="$emit('toggle', !open)">
        <div class="label">
          <slot name="label">
            <span class="label-text" v-html="label"></span>
            <span v-if="formattedSelectedValue || defaultValue" class="default-value">{{ formattedSelectedValue || defaultValue }}</span>
          </slot>
        </div>
        <span v-if="hasRemoveButton" @click="$emit('remove')" class="remove-button">&times;</span>
      </button>
      <!-- TODO: only click on option should close the dropdown -->
      <div v-if="open" class="dropdown">
        <slot />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.app-dropdown {
  position: relative;

  .dropdown-container {
    // margin: 4px;

    .dropdown-button {
      // min-width: 130px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 8px;
      height: 38px;
      font-size: 13px;
      line-height: 11px;
      font-weight: 700;
      color: var(--purple-light-3);
      background: 0;
      border: 1px solid var(--gray-light-4);
      border-radius: 8px;

      span {
        margin: 0 4px;
      }

      .label {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 4px;
        line-height: 0;

        .label-text {
          display: flex;
          align-items: center;
        }

        .default-value {
          color: var(--primary-color);
        }
      }

      .remove-button {
        margin-right: 8px;
        font-size: 18px;
        font-weight: 400;
        color: var(--primary-color);
        cursor: pointer;
      }

      &:focus {
        border: 1px solid var(--purple-light-3);
        outline: none;
      }
    }

    ::v-deep .dropdown {
      position: absolute;
      left: 1px; // border-width, what's the better solution?
      top: 44px;
      padding: 8px 0;
      /// TODO: width of select button should be responsive to dropdown width
      // width: 100%;
      min-width: 132px;
      background: #fff;
      box-shadow: 0 20px 40px #071c4e33;
      border-radius: 8px;
      z-index: 10;
      -webkit-animation: slideUp 0.2s ease;
      animation: slideUp 0.2s ease;
    }

    .option {
      white-space: nowrap;
      padding: 0 16px;
      font-weight: 600;
      font-size: 13px;
      line-height: 26px;
      color: var(--purple-light-3);
      cursor: pointer;

      &.selected {
        color: var(--primary-color);
        pointer-events: none; // not relying on this;
      }

      &:hover {
        color: var(--primary-color);
        background: var(--gray-light-2);
      }
    }
  }
}
</style>
